import { updateItems } from '@/mocks/home';

const typeStyles: Record<string, { dot: string; bg: string; text: string }> = {
  '更新': { dot: 'bg-primary-500', bg: 'bg-primary-100', text: 'text-primary-700' },
  '新作': { dot: 'bg-accent-500', bg: 'bg-accent-100', text: 'text-accent-700' },
  '活动': { dot: 'bg-accent-500', bg: 'bg-accent-100', text: 'text-accent-700' },
  '资讯': { dot: 'bg-secondary-500', bg: 'bg-secondary-100', text: 'text-secondary-700' },
  '功能': { dot: 'bg-primary-500', bg: 'bg-primary-100', text: 'text-primary-700' },
  '出版': { dot: 'bg-secondary-500', bg: 'bg-secondary-100', text: 'text-secondary-700' },
  '事件': { dot: 'bg-secondary-500', bg: 'bg-secondary-100', text: 'text-secondary-700' },
  '里程碑': { dot: 'bg-accent-500', bg: 'bg-accent-100', text: 'text-accent-700' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">更新动态</h2>
          <p className="text-sm md:text-base text-foreground-600">最新连载更新、平台公告与活动资讯</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-5 md:space-y-6">
            {updateItems.map((item) => {
              const s = typeStyles[item.type] || typeStyles['更新'];
              return (
                <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-12">
                  <div className={`absolute left-[15px] md:left-[18px] w-[9px] h-[9px] md:w-[11px] md:h-[11px] rounded-full ${s.dot} ring-4 ring-background-50 mt-1.5`}></div>
                  <div className="flex-1 bg-background-100 rounded-xl md:rounded-2xl p-4 md:p-5 border border-background-200/70 hover:scale-[1.01] transition-all duration-200 cursor-pointer">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className={`text-[10px] md:text-xs px-2 py-0.5 rounded-full font-medium ${s.bg} ${s.text}`}>{item.type}</span>
                      <span className="text-xs text-foreground-400">{item.date}</span>
                    </div>
                    <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}